module.exports = __webpack_public_path__ + "img/public-code.ad994b96.jpg";